module.exports = __webpack_public_path__ + "static/media/image-primary.aaaf65b7.svg";